/**
 * Auth / redirect plumbing. These are written before we know who the user is
 * (or read after they have gone), so they cannot be scoped to an employee.
 */
type GlobalItemKey = "USER_MVC_APP_URL" | "AUTH_RETURN_URL";

/**
 * User chrome preferences. Scoped to the employee so a shared browser (or an
 * admin impersonating someone) does not inherit the previous person's choices.
 */
type EmployeeScopedItemKey =
  | `ACCESSIBILITY_TOOL_HIDDEN_${number}`
  | `COACH_BANNER_DISMISSED_${number}_${string}`
  | `COACH_HIDDEN_${number}_${string}`;

type LocalStorageItemKey = GlobalItemKey | EmployeeScopedItemKey;

export const localStorageKeys = {
  accessibilityToolHidden: (employeeId: number) =>
    `ACCESSIBILITY_TOOL_HIDDEN_${employeeId}` as const,
  coachBannerDismissed: (employeeId: number, answerSetUniqueId: string) =>
    `COACH_BANNER_DISMISSED_${employeeId}_${answerSetUniqueId}` as const,
  coachHidden: (employeeId: number, answerSetUniqueId: string) =>
    `COACH_HIDDEN_${employeeId}_${answerSetUniqueId}` as const,
};

const localStorageHelper = {
  getItem(keyName: LocalStorageItemKey): string | null {
    try {
      return localStorage.getItem(keyName);
    } catch (error) {
      console.log("localStorageHelper error: ", error);
      return null;
    }
  },
  setItem(keyName: LocalStorageItemKey, value: string): void {
    try {
      localStorage.setItem(keyName, value);
    } catch (error) {
      console.log("localStorageHelper error: ", error);
    }
  },
  removeItem(keyName: LocalStorageItemKey): void {
    try {
      localStorage.removeItem(keyName);
    } catch (error) {
      console.log("localStorageHelper error: ", error);
    }
  },
};

export default localStorageHelper;
